<template>
    <div>
        <template v-if="!wapShow">
        <header-hove></header-hove>
        <banner></banner>
        <introduction-title ch-title="产品介绍" en-title="PRODUCT" style="padding-top: 40px"></introduction-title>
        <new-energy style="padding: 0 0 49px 50px " title="新能源材料" :list="newEnergys" :type="1"></new-energy>
        <new-energy style="padding: 0 0 49px 50px " title="腈类化合物及其衍生物" :list="nitrileCompounds" :type="2"></new-energy>
        <new-energy style="padding: 0 0 73px 50px " title="基础化学品" :list="basicss" :type="3"></new-energy>
        <cooperation-opportunities></cooperation-opportunities>
        <information></information>
        <footers></footers>
        </template>
        <template v-else>
            <home-wap></home-wap>
        </template>
    </div>
</template>
<script>
    import headerHove from '@/components/headerHove.vue'
    import banner from "@/views/home/component/banner.vue";
    import IntroductionTitle from "@/components/IntroductionTitle.vue";
    import NewEnergy from "@/views/home/component/newEnergy.vue";
    import footers from "@/components/footer.vue";
    import cooperationOpportunities from "@/views/home/component/cooperationOpportunities";
    import Information from "@/views/home/component/Information";
    import eventBus from "@/assets/js/eventBus";
    import homeWap from "./wap/index"
    export default {
        name: "home",
        components: {footers, NewEnergy, IntroductionTitle, banner, headerHove,cooperationOpportunities,Information,homeWap},
        data() {
            return {
                newEnergys:[],
                nitrileCompounds:[],
                basicss:[],
                wapShow:false
            }
        },
        mounted(){
            const newEnergy =require('../..//assets/JSONData/product/newEnergy.json');
            const nitrileCompound =require('../..//assets/JSONData/product/nitrileCompound.json');
            const basics =require('../..//assets/JSONData/product/basics.json');
            this.newEnergys=newEnergy;
            this.nitrileCompounds=nitrileCompound;
            this.basicss=basics;
            if(this.$route.query) this.wapShow = this.$route.query.wapShow;
            eventBus.$on("wapShow",(data)=>{
                this.wapShow= data;
            })
        }
    }
</script>

<style>
    .listTitle{
        font-size: 30px;
        font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
        font-weight: bold;
        color: #363A44;
        line-height: 40px;
        letter-spacing: 1px;
        text-align: left;
    }

</style>
